import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
Swiper.use([ Navigation ]);

export default () => {

    const swipers = document.querySelectorAll('.video-slider');
    if (!swipers.length) {
        return;
    }

    swipers.forEach((swiperEl) => {

        const allSlides = swiperEl.querySelectorAll('.swiper-slide');
        const containerEl = swiperEl.parentNode;

        if (!allSlides.length) {
            return;
        }

        const videoSwiperOpts = {
            grabCursor: false,
            simulateTouch: true,
            loop: false,
            speed: 600,
            centeredSlides: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 24,
            slideToClickedSlide: false,
            watchSlidesProgress: true,
            autoHeight: false,
            init: false,
            navigation: {
                nextEl: `#${containerEl.id} .next-slide`,
                prevEl: `#${containerEl.id} .prev-slide`,
            },
            pagination: {
                el: `#${containerEl.id} .swiper-pagination`,
                type: 'progressbar',
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1024: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                }
            }
        };

        const swiper = swiperEl.querySelector('.swiper');
        if (swiper) {
            const videoSwiper = new Swiper(swiper, videoSwiperOpts);
            videoSwiper.init();
        }

    });

}